import { defineComponent } from 'vue';
import utils from '../../../Shared/utils.jsx';
import BaseComponentMixin from './BaseComponentMixin.jsx';

export default defineComponent({
    name: 'dynamic-tab-dsgn',
    mixins: [BaseComponentMixin],
    data() {
        return {
            tab_state: {
                index: 0,
            },
        };
    },
    computed: {
        selected$() {
            let anytabs = false;
            if (this.controlData && this.controlData.TabControls) {
                for (let i = 0; i < this.controlData.TabControls.length; i++) {
                    if (this.Root.SelectedModel == this.controlData.TabControls[i]) {
                        anytabs = true;
                        break;
                    }
                }
            }
            return this.Root.SelectedNode && (this.Root.SelectedModel == this.designmodel || anytabs);
        },
    },
    props: {
        //name: { type: String, default: '' },
        //type: { type: String, default: '' },
        //root: { type: Object, default: null },
        //designmodel: { type: Object, default: null },
        //parentType: { type: String, default: '' },
        //controlData: { type: Object, default: () => ({}) },
    },
    render() {
        if (!this.controlData)
            return null;

        const general_tab_style = {
            float: 'left',
            borderTop: '1px solid black',
            borderLeft: '1px solid black',
            borderRight: '1px solid black',
            borderRadius: '8px 8px 0 0',
            maxWidth: '250px',
            minWidth: '50px',
            padding: '2px 5px 1px',
            backgroundColor: 'gray',
            color: 'silver',
        };

        const style = {
            overflow: 'auto',
            display: 'flex',
            flexDirection: 'column',
            minWidth: '25px',
            ...utils.getSize(this.controlData.SizeOptions, this.parentType, this.$parent),
            ...utils.getStyleHints(this.controlData.StyleHints),
        };

        return (
            <div
                class={{
                    'c-DynamicTab': true,
                    [`c-name-${this.name || 'unnamed'}`]: true,
                    'designer-container': true,
                    selected: this.selected$,
                }}
                style={style}
                onClick={(e) => this.handleClick(e)}>
                <div class={{ 'designer-container-hovering': true, 'designer-container-selected-clickthrough': this.selected$ }} />

                <div>
                    <div style={general_tab_style}>
                        <span style={{ cursor: 'pointer' }}>Dynamic Tab</span>
                    </div>
                </div>
            </div>
        );
    },
});
